export default {
  H0454: 'http://tag.hsl.fi/tag/16669?a',
  H0455: 'http://tag.hsl.fi/tag/16670?a',
  H0451: 'http://tag.hsl.fi/tag/16671?a',
  H0453: 'http://tag.hsl.fi/tag/16672?a',
  H0452: 'http://tag.hsl.fi/tag/16673?a',
  H0408: 'http://tag.hsl.fi/tag/16674?a',
  H0425: 'http://tag.hsl.fi/tag/16677?a',
  H0424: 'http://tag.hsl.fi/tag/16678?a',
  H0102: 'http://tag.hsl.fi/tag/16679?a',
  H0101: 'http://tag.hsl.fi/tag/16680?a',
  H0401: 'http://tag.hsl.fi/tag/16681?a',
  H0402: 'http://tag.hsl.fi/tag/16682?a',
  H0403: 'http://tag.hsl.fi/tag/16683?a',
  H0404: 'http://tag.hsl.fi/tag/16684?a',
  H0405: 'http://tag.hsl.fi/tag/16685?a',
  H0301: 'http://tag.hsl.fi/tag/16686?a',
  H0302: 'http://tag.hsl.fi/tag/16687?a',
  H0406: 'http://tag.hsl.fi/tag/16688?a',
  H0303: 'http://tag.hsl.fi/tag/16689?a',
  H0305: 'http://tag.hsl.fi/tag/16690?a',
  H0306: 'http://tag.hsl.fi/tag/16691?a',
  H0701: 'http://tag.hsl.fi/tag/16692?a',
  H0702: 'http://tag.hsl.fi/tag/16693?a',
  H0705: 'http://tag.hsl.fi/tag/16694?a',
  H0709: 'http://tag.hsl.fi/tag/16695?a',
  H0430: 'http://tag.hsl.fi/tag/16696?a',
  H0431: 'http://tag.hsl.fi/tag/16697?a',
  H0432: 'http://tag.hsl.fi/tag/16698?a',
  H0433: 'http://tag.hsl.fi/tag/16699?a',
  H0703: 'http://tag.hsl.fi/tag/16700?a',
  H0803: 'http://tag.hsl.fi/tag/16701?a',
  H0232: 'http://tag.hsl.fi/tag/16702?a',
  H0201: 'http://tag.hsl.fi/tag/16703?a',
  H0820: 'http://tag.hsl.fi/tag/16705?a',
  H0821: 'http://tag.hsl.fi/tag/16706?a',
  H0822: 'http://tag.hsl.fi/tag/16707?a',
  H0823: 'http://tag.hsl.fi/tag/16708?a',
  H0824: 'http://tag.hsl.fi/tag/16709?a',
  H0825: 'http://tag.hsl.fi/tag/16710?a',
  H0234: 'http://tag.hsl.fi/tag/16712?a',
  H0233: 'http://tag.hsl.fi/tag/16713?a',
  H0801: 'http://tag.hsl.fi/tag/16714?a',
  H0804: 'http://tag.hsl.fi/tag/16715?a',
  H0805: 'http://tag.hsl.fi/tag/16716?a',
  H0809: 'http://tag.hsl.fi/tag/16717?a',
  H0802: 'http://tag.hsl.fi/tag/16718?a',
  H0811: 'http://tag.hsl.fi/tag/16719?a',
  H0217: 'http://tag.hsl.fi/tag/16720?a',
  H0218: 'http://tag.hsl.fi/tag/16721?a',
  H0813: 'http://tag.hsl.fi/tag/16722?a',
  H0815: 'http://tag.hsl.fi/tag/16723?a',
  H0445: 'http://tag.hsl.fi/tag/16724?a',
  H0807: 'http://tag.hsl.fi/tag/16728?a',
  H0438: 'http://tag.hsl.fi/tag/16729?a',
  H0439: 'http://tag.hsl.fi/tag/16730?a',
  H0436: 'http://tag.hsl.fi/tag/16731?a',
  H0442: 'http://tag.hsl.fi/tag/16732?a',
  H0443: 'http://tag.hsl.fi/tag/16733?a',
  H0440: 'http://tag.hsl.fi/tag/16734?a',
  H0441: 'http://tag.hsl.fi/tag/16735?a',
  H0437: 'http://tag.hsl.fi/tag/16737?a',
  H0708: 'http://tag.hsl.fi/tag/16744?a',
  H0707: 'http://tag.hsl.fi/tag/16745?a',
  H0410: 'http://tag.hsl.fi/tag/16747?a',
  H0412: 'http://tag.hsl.fi/tag/16748?a',
  H0414: 'http://tag.hsl.fi/tag/16749?a',
  H0416: 'http://tag.hsl.fi/tag/16750?a',
  H0420: 'http://tag.hsl.fi/tag/16751?a',
  H0421: 'http://tag.hsl.fi/tag/16752?a',
  H0434: 'http://tag.hsl.fi/tag/16753?a',
  H0435: 'http://tag.hsl.fi/tag/16754?a',
  H0253: 'http://tag.hsl.fi/tag/16755?a',
  H0307: 'http://tag.hsl.fi/tag/16756?a',
  H0251: 'http://tag.hsl.fi/tag/16757?a',
  H0252: 'http://tag.hsl.fi/tag/16758?a',
  H0308: 'http://tag.hsl.fi/tag/16759?a',
  H0255: 'http://tag.hsl.fi/tag/16761?a',
  H0256: 'http://tag.hsl.fi/tag/16762?a',
  H0258: 'http://tag.hsl.fi/tag/16763?a',
  H0227: 'http://tag.hsl.fi/tag/16764?a',
  H0228: 'http://tag.hsl.fi/tag/16765?a',
  H0229: 'http://tag.hsl.fi/tag/16766?a',
  H0230: 'http://tag.hsl.fi/tag/16767?a',
  H0257: 'http://tag.hsl.fi/tag/16768?a',
  H0309: 'http://tag.hsl.fi/tag/16769?a',
  H0310: 'http://tag.hsl.fi/tag/16770?a',
  H0312: 'http://tag.hsl.fi/tag/16771?a',
  H0651: 'http://tag.hsl.fi/tag/16773?a',
  H0652: 'http://tag.hsl.fi/tag/16774?a',
  H0261: 'http://tag.hsl.fi/tag/16775?a',
  H0250: 'http://tag.hsl.fi/tag/16778?a',
  H0313: 'http://tag.hsl.fi/tag/16779?a',
  H0314: 'http://tag.hsl.fi/tag/16780?a',
  H0262: 'http://tag.hsl.fi/tag/16782?a',
  H0245: 'http://tag.hsl.fi/tag/16783?a',
  H0247: 'http://tag.hsl.fi/tag/16784?a',
  H0248: 'http://tag.hsl.fi/tag/16785?a',
  H0249: 'http://tag.hsl.fi/tag/16786?a',
  H0259: 'http://tag.hsl.fi/tag/16787?a',
  H0260: 'http://tag.hsl.fi/tag/16788?a',
  H0654: 'http://tag.hsl.fi/tag/16789?a',
  H0633: 'http://tag.hsl.fi/tag/16790?a',
  H0634: 'http://tag.hsl.fi/tag/16791?a',
  H0635: 'http://tag.hsl.fi/tag/16792?a',
  H0636: 'http://tag.hsl.fi/tag/16793?a',
  H0631: 'http://tag.hsl.fi/tag/16799?a',
  H0632: 'http://tag.hsl.fi/tag/16800?a',
  H0246: 'http://tag.hsl.fi/tag/16801?a',
  H0202: 'http://tag.hsl.fi/tag/16802?a',
  H0103: 'http://tag.hsl.fi/tag/16803?a',
  H0104: 'http://tag.hsl.fi/tag/16804?a',
  H0105: 'http://tag.hsl.fi/tag/16805?a',
  H0106: 'http://tag.hsl.fi/tag/16806?a',
  H0203: 'http://tag.hsl.fi/tag/16809?a',
  H0205: 'http://tag.hsl.fi/tag/16810?a',
  H0206: 'http://tag.hsl.fi/tag/16811?a',
  H0207: 'http://tag.hsl.fi/tag/16812?a',
  H0208: 'http://tag.hsl.fi/tag/16813?a',
  H0219: 'http://tag.hsl.fi/tag/16814?a',
  H0220: 'http://tag.hsl.fi/tag/16815?a',
  H0221: 'http://tag.hsl.fi/tag/16816?a',
  H0222: 'http://tag.hsl.fi/tag/16817?a',
  H0107: 'http://tag.hsl.fi/tag/16818?a',
  H0108: 'http://tag.hsl.fi/tag/16819?a',
  H0109: 'http://tag.hsl.fi/tag/16820?a',
  H0110: 'http://tag.hsl.fi/tag/16821?a',
  H0641: 'http://tag.hsl.fi/tag/16822?a',
  H0112: 'http://tag.hsl.fi/tag/16823?a',
  H0111: 'http://tag.hsl.fi/tag/16824?a',
  H0209: 'http://tag.hsl.fi/tag/16825?a',
  H0210: 'http://tag.hsl.fi/tag/16826?a',
  H0241: 'http://tag.hsl.fi/tag/16827?a',
  H0242: 'http://tag.hsl.fi/tag/16828?a',
  H0243: 'http://tag.hsl.fi/tag/16829?a',
  H0244: 'http://tag.hsl.fi/tag/16830?a',
  H0113: 'http://tag.hsl.fi/tag/16831?a',
  H0114: 'http://tag.hsl.fi/tag/16832?a',
  H0115: 'http://tag.hsl.fi/tag/16833?a',
  H0116: 'http://tag.hsl.fi/tag/16834?a',
  H0117: 'http://tag.hsl.fi/tag/16835?a',
  H0118: 'http://tag.hsl.fi/tag/16836?a',
  H0119: 'http://tag.hsl.fi/tag/16837?a',
  H0120: 'http://tag.hsl.fi/tag/16838?a',
  H0142: 'http://tag.hsl.fi/tag/16839?a',
  H0144: 'http://tag.hsl.fi/tag/16840?a',
  H0140: 'http://tag.hsl.fi/tag/16841?a',
  H0604: 'http://tag.hsl.fi/tag/16842?a',
  H0603: 'http://tag.hsl.fi/tag/16843?a',
  H0606: 'http://tag.hsl.fi/tag/16844?a',
  H0605: 'http://tag.hsl.fi/tag/16845?a',
  H0608: 'http://tag.hsl.fi/tag/16846?a',
  H0607: 'http://tag.hsl.fi/tag/16847?a',
  H0640: 'http://tag.hsl.fi/tag/16848?a',
  H0638: 'http://tag.hsl.fi/tag/16849?a',
  H0637: 'http://tag.hsl.fi/tag/16850?a',
  H0602: 'http://tag.hsl.fi/tag/16851?a',
  H0601: 'http://tag.hsl.fi/tag/16852?a',
  H0663: 'http://tag.hsl.fi/tag/16853?a',
  H0620: 'http://tag.hsl.fi/tag/16854?a',
  H0662: 'http://tag.hsl.fi/tag/16855?a',
  H0661: 'http://tag.hsl.fi/tag/16856?a',
  H0273: 'http://tag.hsl.fi/tag/16860?a',
  H0274: 'http://tag.hsl.fi/tag/16861?a',
  H0276: 'http://tag.hsl.fi/tag/16862?a',
  H0618: 'http://tag.hsl.fi/tag/16863?a',
  H0617: 'http://tag.hsl.fi/tag/16864?a',
  H0614: 'http://tag.hsl.fi/tag/16865?a',
  H0611: 'http://tag.hsl.fi/tag/16866?a',
  H0133: 'http://tag.hsl.fi/tag/16868?a',
  H0134: 'http://tag.hsl.fi/tag/16869?a',
  H0136: 'http://tag.hsl.fi/tag/16870?a',
  H0137: 'http://tag.hsl.fi/tag/16871?a',
  H0138: 'http://tag.hsl.fi/tag/16872?a',
  H0639: 'http://tag.hsl.fi/tag/16873?a',
  H0215: 'http://tag.hsl.fi/tag/16874?a',
  H0214: 'http://tag.hsl.fi/tag/16875?a',
  H0213: 'http://tag.hsl.fi/tag/16876?a',
  H0291: 'http://tag.hsl.fi/tag/16877?a',
  H0212: 'http://tag.hsl.fi/tag/16881?a',
  H0287: 'http://tag.hsl.fi/tag/16882?a',
  H0297: 'http://tag.hsl.fi/tag/16883?a',
  H0293: 'http://tag.hsl.fi/tag/16884?a',
  H0295: 'http://tag.hsl.fi/tag/16885?a',
  H0236: 'http://tag.hsl.fi/tag/16887?a',
  H0277: 'http://tag.hsl.fi/tag/16889?a',
  H0238: 'http://tag.hsl.fi/tag/16890?a',
  H0239: 'http://tag.hsl.fi/tag/16891?a',
  H0288: 'http://tag.hsl.fi/tag/16892?a',
  H0286: 'http://tag.hsl.fi/tag/16893?a',
  H0653: 'http://tag.hsl.fi/tag/16894?a',
  H0655: 'http://tag.hsl.fi/tag/16895?a',
  H0660: 'http://tag.hsl.fi/tag/16896?a',
  H0330: 'http://tag.hsl.fi/tag/16897?a',
  H0316: 'http://tag.hsl.fi/tag/16898?a',
  H0318: 'http://tag.hsl.fi/tag/16899?a',
  H0320: 'http://tag.hsl.fi/tag/16900?a',
  H0329: 'http://tag.hsl.fi/tag/16901?a',
  H0264: 'http://tag.hsl.fi/tag/16902?a',
  H0265: 'http://tag.hsl.fi/tag/16903?a',
  H0266: 'http://tag.hsl.fi/tag/16904?a',
  H0267: 'http://tag.hsl.fi/tag/16905?a',
  H0268: 'http://tag.hsl.fi/tag/16906?a',
  H0269: 'http://tag.hsl.fi/tag/16907?a',
  H0270: 'http://tag.hsl.fi/tag/16908?a',
  H0331: 'http://tag.hsl.fi/tag/16909?a',
  H0332: 'http://tag.hsl.fi/tag/16910?a',
  H0333: 'http://tag.hsl.fi/tag/16911?a',
  H0334: 'http://tag.hsl.fi/tag/16912?a',
  H0271: 'http://tag.hsl.fi/tag/16913?a',
  H0272: 'http://tag.hsl.fi/tag/16914?a',
  H0658: 'http://tag.hsl.fi/tag/16915?a',
  H0659: 'http://tag.hsl.fi/tag/16916?a',
  H0656: 'http://tag.hsl.fi/tag/16917?a',
  H0657: 'http://tag.hsl.fi/tag/16918?a',
  H0612: 'http://tag.hsl.fi/tag/16920?a',
  H0336: 'http://tag.hsl.fi/tag/16922?a',
  H0327: 'http://tag.hsl.fi/tag/16923?a',
  H0328: 'http://tag.hsl.fi/tag/16924?a',
  H0326: 'http://tag.hsl.fi/tag/16925?a',
  H0280: 'http://tag.hsl.fi/tag/16926?a',
  H0282: 'http://tag.hsl.fi/tag/16927?a',
  H0284: 'http://tag.hsl.fi/tag/16928?a',
  H0285: 'http://tag.hsl.fi/tag/16929?a',
  H0146: 'http://tag.hsl.fi/tag/16930?a',
  H0148: 'http://tag.hsl.fi/tag/16931?a',
  H0122: 'http://tag.hsl.fi/tag/16932?a',
  H0124: 'http://tag.hsl.fi/tag/16933?a',
  H0126: 'http://tag.hsl.fi/tag/16934?a',
};
